import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { NavigationStore } from '../navigation/navigation.store';
import { PermissionCode } from '../navigation/navigation.models';

/**
 * Factory de guard por permiso: `permissionGuard('fleet.vehicles.read')`.
 *
 * Reemplaza a `roleGuard` (M21). La lista de permisos llega en
 * `GET /v1/me/navigation`, así que el guard ESPERA a `ensureLoaded()` antes de
 * decidir: leer el signal directo rechazaría toda entrada en frío por URL o F5,
 * cuando la lista todavía está vacía, y dejaría al usuario encerrado fuera de su
 * propio portal — sin red, porque el §4.1 del contrato prohíbe el menú de respaldo.
 *
 * Distingue los dos fracasos, que no son el mismo: "no tenés permiso" es de la
 * cuenta del usuario; "no pude leer la navegación" es una caída del backend, y
 * mandarla a /not-authorized le mentiría sobre por qué no entra.
 *
 * La autorización REAL la hace el backend (403); esto es sólo routing.
 */
export function permissionGuard(permission: PermissionCode): CanActivateFn {
  return async () => {
    const nav = inject(NavigationStore);
    const router = inject(Router);

    await nav.ensureLoaded();

    if (nav.status() !== 'ready') return router.createUrlTree(['/navigation-unavailable']);
    if (nav.hasPermission(permission)) return true;
    return router.createUrlTree(['/not-authorized']);
  };
}
